<template>
<div class="ActivityPoster bgc box-shadow">
    <div class="eventinfo">
        <img class="img" :src="eventinfo.coveratturlid" alt="">
        <div>
            <div class="title">{{eventinfo.title}}</div>
            <div>
                <span :class="'type '+resulttype(eventinfo.resulttype)">{{eventinfo.resulttypename}}</span>
                <span :class="'type '+eventstatus(eventinfo.eventstatus)">{{eventinfo.eventstatusname}}</span>
            </div>
        </div>
    </div>
    <div class="ActivityPoster-content">
        <div class="poster-title"><p>海报设置</p></div>
        <div class="contentBox">
            <el-form :model="item" :rules="rules" ref="ruleForm" label-width="135px" class="demo-ruleForm">
                <el-form-item label="海报图片" class="cover" prop="posterkeyurl">
                    <div class="imgBox">
                        <i class="el-icon-picture" v-if="!item.posterkeyurl"></i>
                        <img class="activityCoverImage" :src="item.posterkeyurl + '?' + time"
                             v-else-if="item.posterkeyurl + '?' + time"
                             alt="">
                    </div>
                    <div class="uploadFileBox">
                        <el-button @click.native="openDialog">选择文件</el-button>
                        <p>建议尺寸670*894px或者4:3尺寸的JPG、PNG格式， 图片小于2M。</p>
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
    <div class="btns bgc box-shadow">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="submitForm">提交</el-button>
    </div>
    <ShopLocalCropper :cropperOption="cropperOption" ref="localCropper" @setImage="_setImage"
                      :uploadType="uploadType"></ShopLocalCropper>
</div>
</template>

<script>
import {getEventDatailInfo, updateEventPosterInfo} from 'api/brandBusiness'
import ShopLocalCropper from 'base/cropper/shopLocalCropper'
import {mapGetters, mapActions} from 'vuex'
import {brandBusiness} from 'api/enumCode'
export default {
    name: 'ActivityPoster',
    data() {
        return {
            param: {
                eventid: this.$route.query.eventid ? this.$route.query.eventid : '',
                eventtype: 10
            },
            item: {
                eventid: this.$route.query.eventid ? this.$route.query.eventid : '',
                eventtype: 10,
                posterid: '',
                posterkeyid: '',
                posterkeyurl: '',
            },
            rules: {
                posterkeyurl: [
                    {required: true, message: '请选择上传海报', trigger: 'blur'}
                ]
            },
            time: new Date().getTime(),
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            cropperOption: {
                fixedNumber: [670, 894], // 截图框的宽高比例
                enlarge: 2.5, // 图片根据截图框输出比例倍数
                autoCropWidth: 268, // 默认生成截图框宽度
                autoCropHeight: 356 // 默认生成截图框高度
            },
            eventinfo: {}
        }
    },
    mounted() {
        this._getView()
    },
    methods: {
        submitForm() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this._save()
                }
            })
        },
        cancel() {
            this.$router.back()
        },
        openDialog() {
            this.$refs.localCropper.openDialog()
        },
        _setImage(file) {
            this.time = new Date().getTime()
            this.item.posterkeyurl = file.furl
            this.item.posterkeyid = file.key
        },
        _save() {
            this.setLoading(true)
            updateEventPosterInfo({
                data: Object.assign({}, this.item),
                success: data => {
                    this.$message.success('提交成功')
                    this.setLoading(false)
                    this.cancel()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getView() {
            this.setLoading(true)
            getEventDatailInfo({
                data: Object.assign({}, this.param),
                success: data => {
                    this.eventinfo = data.data
                    this.item.posterkeyid = this.eventinfo.posterkeyid
                    this.item.posterkeyurl = this.eventinfo.posterkeyurl
                    this.item.posterid = this.eventinfo.posterid
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        resulttype() {
            return function (value) {
                for (let i = 0; i < brandBusiness.resulttype.length; i++) {
                    if (value === brandBusiness.resulttype[i].code) {
                        return brandBusiness.resulttype[i].cls
                    }
                }
                return value
            }
        },
        eventstatus() {
            return function (value) {
                for (let i = 0; i < brandBusiness.eventstatus.length; i++) {
                    if (value === brandBusiness.eventstatus[i].code) {
                        return brandBusiness.eventstatus[i].cls
                    }
                }
                return value
            }
        },
    },
    components: {
        ShopLocalCropper
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.ActivityPoster {
    padding: 20px;
    .eventinfo{
        display: flex;
        background: #FAFAFA;
        padding: 20px;
        margin-bottom: 30px;
        .img{
            width: 180px;
            height: 102px;
            margin-right: 30px;
        }
        .title{
            margin-bottom: 10px;
        }
        .type{
            margin-right: 20px;
        }
    }
    .poster-title {
        padding-bottom: 20px;
        border-bottom: 1px solid #DCDFE6;
        p {
            border-left: 2px solid #409EFF;
            text-indent: 8px;
            font-size: 14px;
            font-weight: bold;
        }
    }
    .contentBox{
        margin-top: 30px;
    }
    .el-form-item__content {
        display: flex;
        align-items: center;
        .imgBox {
            width: 268px;
            height: 356px;
            background: #F5F7FA;
            text-align: center;
            line-height: 356px;
            .el-icon-picture, .el-icon-video-camera-solid {
                color: #DCDFE6;
                font-size: 40px;
            }
            .activityCoverImage {
                width: 268px;
                height: 356px;
            }
        }
        .uploadFileBox {
            margin-left: 12px;
            .uploadFile {
                .upload-demo {
                    .el-upload {
                        .el-button {
                            background: #fff;
                            color: #000;
                            border: 1px solid #C0C4CC;
                        }
                    }
                }
            }
            p {
                color: #909399;
                font-size: 14px;
                line-height: 20px;
            }
        }
    }
    .btns{
        position: fixed;
        left:180px;
        right: 0;
        bottom: 0;
        height: 80px;
        display: flex;
        align-items: center;
        justify-content: center;

    }
}
</style>
